export const APPLICATION_AUTO_DECLINE_ANNOUNCEMENT_KEY = 'application-auto-decline';

export type ReviewWindowBrand = {
  id?: string;
  autoDeclineDays?: number | null;
} | null | undefined;

export interface ReviewWindowExplainerGate {
  brandId: string;
  days: number;
}

export function reviewWindowExplainerGate(
  brand: ReviewWindowBrand,
): ReviewWindowExplainerGate | null {
  const brandId = brand?.id;
  const days = brand?.autoDeclineDays;
  if (!brandId || typeof days !== 'number' || days <= 0) {
    return null;
  }
  return { brandId, days };
}

export function formatReviewWindowDays(days: number): string {
  return days === 1 ? '1 day' : `${days} days`;
}

export function resolveExplainerDays(
  requestedDays: number | null | undefined,
  brandDays: number | null | undefined,
): number | null {
  if (typeof requestedDays === 'number' && requestedDays > 0) {
    return requestedDays;
  }
  if (typeof brandDays === 'number' && brandDays > 0) {
    return brandDays;
  }
  return null;
}
